<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">{{'Checking product visibility errors' | uppercase}}</h1>
		</div>

		<div class="row mt-4">
			<div class="col-4">
				<h5>Enter commercial code and customer</h5>
			</div>
			<div class="col-8 d-flex">
				<input
					class="dt-no-export font-weight-bold font-12 mr-2"
					placeholder="COMMERCIAL CODE"
					name="codiceCommerciale"
					[(ngModel)]="payloadVisibilitaProdotti.codiceCommerciale" />
				<select class="minimal w-100  rounded-0 border-black" name="idCliente" [(ngModel)]="payloadVisibilitaProdotti.idCliente">
					<option [ngValue]="undefined">SELECT</option>
					<option *ngFor="let cliente of clienti" [value]="cliente.id">{{cliente.ragioneSociale}}</option>
				</select>
				<button
					type="button"
					class="btn btn-bertazzoni black rounded-0 ml-3"
					[disabled]="!payloadVisibilitaProdotti.codiceCommerciale || !payloadVisibilitaProdotti.idCliente"
					(click)="controlloVisibilita()">
					SEND
				</button>
			</div>
		</div>
	</div>
</div>
